<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 id="toc-title">Apocalypse Dawn</h1><ol class="toc" style="font-weight: bold;"><li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li><li id="toc-li-2"><a href="#/text/ch002#dedication">Dedication</a></li><li id="toc-li-3"><a href="#/text/ch003#copyright-information">Copyright Information ©</a></li><li id="toc-li-4"><a href="#/text/ch004#acknowledgement">Acknowledgement</a></li><li id="toc-li-5"><a href="#/text/ch005#apocalypse">Apocalypse?</a></li><li id="toc-li-6"><a href="#/text/ch006#foreword">Foreword</a></li><li id="toc-li-7"><a href="#/text/ch007#overture">Overture</a>
</li><li id="toc-li-9"><a href="#/text/ch008#introduction">Introduction</a>
</li><li id="toc-li-11"><a href="#/text/ch009#prologue">Prologue</a>
</li><li id="toc-li-14"><span href="#/text/ch010#part-one" title="Link target outside of Sample">Part One</span>
</li><li id="toc-li-18"><span href="#/text/ch011#part-two" title="Link target outside of Sample">Part Two</span>
</li><li id="toc-li-25"><span href="#/text/ch012#part-three" title="Link target outside of Sample">Part Three</span>
</li><li id="toc-li-31"><span href="#/text/ch013#part-four" title="Link target outside of Sample">Part Four</span>
</li><li id="toc-li-36"><span href="#/text/ch014#part-five" title="Link target outside of Sample">Part Five</span>
</li><li id="toc-li-41"><span href="#/text/ch015#part-six" title="Link target outside of Sample">Part Six</span>
</li><li id="toc-li-47"><span href="#/text/ch016#part-seven" title="Link target outside of Sample">Part Seven</span>
</li><li id="toc-li-51"><span href="#/text/ch017#epilogue" title="Link target outside of Sample">Epilogue</span>
</li><li id="toc-li-53"><span href="#/text/ch018#finale" title="Link target outside of Sample">Finale</span></li><li id="toc-li-54"><span href="#/text/ch019#johns-fingerprints" title="Link target outside of Sample">John’s “Fingerprints”</span></li><li id="toc-li-55"><span href="#/text/ch020#bibliography" title="Link target outside of Sample">Bibliography</span></li></ol></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?927a3782